import TOHU_CHATBOT_CONFIG from './tohuChatbotConfig'

export { TOHU_CHATBOT_CONFIG }
